function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
  id: "e394fe7a-070b-485b-887c-a0deda057f9a",
  x: 40.76,
  y: 56.26,
  width: 33.73,
  height: 29.27,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  className: "b88d8cff-46eb-4315-baf4-42df03ea0188",
  d: "M73.92 76.91a17.87 17.87 0 11-30.58-18.49C48.44 50 79 68.47 73.92 76.91z"
})), /*#__PURE__*/React.createElement("mask", {
  id: "ae51b4eb-7333-48b4-bd9b-9e6ce0b2d058",
  x: 91.99,
  y: 56.26,
  width: 33.73,
  height: 29.27,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  className: "b88d8cff-46eb-4315-baf4-42df03ea0188",
  d: "M92.56 76.91a17.87 17.87 0 1030.58-18.49C118 50 87.45 68.47 92.56 76.91z"
})), /*#__PURE__*/React.createElement("style", null, ".b88d8cff-46eb-4315-baf4-42df03ea0188{fill:#fff}.aa99b1bd-f709-4800-b35e-22d460fd4cb0{fill:#e8decd}.a3ddeee3-d538-4f46-bda4-0e413e8c62af{fill:none;stroke-linecap:round;stroke:#dbc6a9;stroke-linejoin:round;stroke-width:4.3px}"));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "aa99b1bd-f709-4800-b35e-22d460fd4cb0",
  cx: 81.5,
  cy: 40.06,
  r: 40.06
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  className: "aa99b1bd-f709-4800-b35e-22d460fd4cb0",
  cx: 41.52,
  cy: 67.99,
  r: 24.76
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  className: "aa99b1bd-f709-4800-b35e-22d460fd4cb0",
  cx: 73.21,
  cy: 122.46,
  r: 46.05
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  className: "aa99b1bd-f709-4800-b35e-22d460fd4cb0",
  cx: 122.73,
  cy: 55.61,
  r: 22.28
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  className: "aa99b1bd-f709-4800-b35e-22d460fd4cb0",
  cx: 127.68,
  cy: 101.16,
  r: 29.22
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  className: "aa99b1bd-f709-4800-b35e-22d460fd4cb0",
  cx: 103.42,
  cy: 79.87,
  r: 24.26
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "a3ddeee3-d538-4f46-bda4-0e413e8c62af",
  d: "M64.88 43.3V12.1M89.61 39.65l27.38-27.38M134.19 93.75l18.01 27.57M123.16 47.13h29.77M72.07 72.62H44.51M65.73 122.86l-22.6 22.6M73.91 147.97v32.35M92.66 126.29l26.1 26.1M35.23 83.74H2.15"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "b88d8cff-46eb-4315-baf4-42df03ea0188",
  d: "M73.92 76.91a17.87 17.87 0 11-30.58-18.49C48.44 50 79 68.47 73.92 76.91z"
});

var _ref11 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#e394fe7a-070b-485b-887c-a0deda057f9a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 64.68,
  cy: 74.35,
  r: 5.86
}));

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "b88d8cff-46eb-4315-baf4-42df03ea0188",
  d: "M92.56 76.91a17.87 17.87 0 1030.58-18.49C118 50 87.45 68.47 92.56 76.91z"
});

var _ref13 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#ae51b4eb-7333-48b4-bd9b-9e6ce0b2d058)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 101.79,
  cy: 74.35,
  r: 5.86
}));

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "b88d8cff-46eb-4315-baf4-42df03ea0188",
  d: "M48.78 116.56c-3-2.2-6.05-11.35-1.21-15.24s12.81 1.39 14.31 4.74M65.56 104.32c-1.66-3.29-.69-12.7 5.11-14s10.65 6.83 10.57 10.51M85.24 100.82C85.16 97.14 90 89 95.8 90.31s6.78 10.72 5.12 14M104.6 106.06c1.5-3.35 9.43-8.58 14.3-4.74s1.75 13-1.2 15.24"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M48.65 118.08a44.62 44.62 0 0169.17 0",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: "3.8px",
  fill: "none",
  strokeLinecap: "round"
});

function SvgDust(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a39b35a0-10c6-4459-9af4-a625bb87cbb0",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 156.9 182.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDust);
export default __webpack_public_path__ + "static/media/dust.5032618e.svg";
export { ForwardRef as ReactComponent };